import React from 'react';
import styled from 'styled-components';
import CamaraArgentina from '../../../assets/images/camara-argentina.png';
import Endeavor from '../../../assets/images/endeavor_.png';
import Utn from '../../../assets/images/logo_utn.png';
import MP from '../../../assets/images/mercado-pago.png';
import TopTen from '../../../assets/images/top-ten.png';
import Fintech from '../../../assets/images/fintech_mx.png';
import FacilitaPay from '../../../assets/images/facilitapaylogo.png';
import Spei from '../../../assets/images/speilogo.png';
import { Box, Copy } from '../../SimpleUI';
import SectionLayout from '../SectionLayout';
import { useCountry } from '../../../contexts/CountryContext';
import useDesignUtils from '../../../hooks/useDesignUtils';

const Wrapper = styled(Box)`
  width: 100%;
  margin: auto;
  position: relative;
  min-height: 150px;

  & > div {
    border: 1.5px solid #845cff;
    border-radius: 10px;
    width: 100%;
    height: auto;
    min-height: 150px;
    &:first-child {
      background: white;
      position: inherit;
      z-index: 2;
      padding: 20px;
    }
  }
  &:before {
    content: '';
    z-index: 1;
    padding: 20px;
    width: 100%;
    height: 100%;
    display: inline-block;
    position: absolute;
    border: 1.5px solid #845cff;
    top: 15px;
    left: -17px;
    border-radius: 10px;
  }
`;

const Sponsors = () => {
  const { countryPrefix } = useCountry();
  const { isMobile } = useDesignUtils();

  const allianceType = {
    '/ar': [
      { icon: MP },
      { icon: CamaraArgentina },
      { icon: Endeavor },
      { icon: isMobile ? TopTen : Utn },
      { icon: isMobile ? Utn : TopTen },
    ],
    '/mx': [
      { icon: Fintech },
      { icon: FacilitaPay },
      { icon: Spei },
      { icon: Endeavor },
      { icon: TopTen },
    ],
  };

  return (
    <SectionLayout paddingY="medium" backgroundColor="white">
      <Box
        width="95%"
        paddingX="medium"
        maxWidth="1200px"
        margin="auto"
        marginY={{ mobile: 'none', desktop: 'medium' }}
      >
        <Wrapper>
          <div>
            <Copy color="_darkGray" fontSize="bigText" fontWeight="semibold">
              En colaboración con
            </Copy>
            <Box display="flex" flexWrap="wrap" justifyContent="space-between">
              {allianceType[countryPrefix]?.map((press, i) => (
                <Box
                  key={i}
                  tag="img"
                  src={press.icon}
                  objectFit="contain"
                  margin="medium"
                  maxWidth={{ mobile: '30%', desktop: 'auto' }}
                />
              ))}
            </Box>
          </div>
        </Wrapper>
      </Box>
    </SectionLayout>
  );
};

export { Sponsors };
